import Beta from './Beta.jsx';

export default Beta;